export const isNotFoundSpaceError = (error: Error) => error.message?.includes('Cannot find space');
